export const REQUEST_CREATE_WEVO = "REQUEST_CREATE_WEVO";
export const CREATE_WEVO_SUCCESS = "REQUEST_WEVO_SUCCESS";
export const CREATE_WEVO_ERROR = "CREATE_WEVO_ERROR";

export const REQUEST_SAVE_WEVO = "REQUEST_SAVE_WEVO";
export const SAVE_WEVO_SUCCESS = "SAVE_WEVO_SUCCESS";
export const SAVE_WEVO_ERROR = "SAVE_WEVO_ERROR";

export const REQUEST_CREATE_PAGE = "REQUEST_CREATE_PAGE";
export const CREATE_PAGE_SUCCESS = "CREATE_PAGE_SUCCESS";
export const CREATE_PAGE_ERROR = "CREATE_PAGE_ERROR";

export const REQUEST_UPDATE_PAGE = "REQUEST_UPDATE_PAGE";
export const UPDATE_PAGE_SUCCESS = "UPDATE_PAGE_SUCCESS";
export const UPDATE_PAGE_ERROR = "UPDATE_PAGE_ERROR";

export const REMOVE_SELECTED_PAGE_ERROR_CARD =
    "REMOVE_SELECTED_PAGE_ERROR_CARD";

export const UPLOAD_IMAGE_FOR_PAGE = "IMAGE_UPLOAD_FOR_PAGE";
export const IMAGE_UPLOAD_SUCCESS = "IMAGE_UPLOAD_SUCCESS";
export const IMAGE_UPLOAD_ERROR = "IMAGE_UPLOAD_ERROR";

export const REQUEST_RETRIEVE_PAGE = "REQUEST_RETRIEVE_PAGE";
export const RETRIEVE_PAGE_SUCCESS = "RETRIEVE_PAGE_SUCCESS";
export const RETRIEVE_PAGE_ERROR = "RETRIEVE_PAGE_ERROR";

export const REQUEST_REMOVE_PAGE = "REQUEST_REMOVE_PAGE";
export const REMOVE_PAGE_SUCCESS = "REMOVE_PAGE_SUCCESS";
export const REMOVE_PAGE_ERROR = "REMOVE_PAGE_ERROR";

export const REQUEST_CREATE_CTA = "REQUEST_CREATE_CTA";
export const CREATE_CTA_SUCCESS = "CREATE_CTA_SUCCESS";
export const CREATE_CTA_ERROR = "CREATE_CTA_ERROR";

export const REQUEST_REMOVE_CTA = "REQUEST_REMOVE_CTA";
export const REMOVE_CTA_SUCCESS = "REMOVE_CTA_SUCCESS";
export const REMOVE_CTA_ERROR = "REMOVE_CTA_ERROR";

export const REQUEST_ATTACH_AUDIENCE = "REQUEST_ATTACH_AUDIENCE";
export const ATTACH_AUDIENCE_SUCCESS = "ATTACH_AUDIENCE_SUCCESS";
export const ATTACH_AUDIENCE_ERROR = "ATTACH_AUDIENCE_FAILURE";

export const REQUEST_DETACH_AUDIENCE = "REQUEST_DETACH_AUDIENCE";
export const DETACH_AUDIENCE_SUCCESS = "DETACH_AUDIENCE_SUCCESS";
export const DETACH_AUDIENCE_ERROR = "DETACH_AUDIENCE_ERROR";

export const REQUEST_UPDATE_AUDIENCE_SEGMENT =
    "REQUEST_UPDATE_AUDIENCE_SEGMENT";
export const UPDATE_AUDIENCE_SEGMENT_SUCCESS =
    "UPDATE_AUDIENCE_SEGMENT_SUCCESS";
export const UPDATE_AUDIENCE_SEGMENT_ERROR = "UPDATE_AUDIENCE_SEGMENT_ERROR";

export const CLEAR_STATUS_STATE = "WEVO_CONFIGURATION_CLEAR_STATUS_STATE";

export const TOGGLE_QUOTA_EDITOR_FOR_AUDIENCE =
    "TOGGLE_QUOTA_EDITOR_FOR_AUDIENCE";



// WEBPACK FOOTER //
// ./src/modules/configure-wevo/types.js